import axios from 'axios';

export default {
    getCSRF() {
        return axios.get(`${process.env.Backend_URL}/sanctum/csrf-cookie`);
    },
    verifyEmail(id) {
        return axios.get(`${process.env.API_URL}/email/verify/${id}`);
    },
    login(loginObj) {
        return axios.post(`${process.env.Backend_URL}/login`, loginObj);
    },
    logout() {
        localStorage.setItem("isLoggedIn", false);
        localStorage.removeItem("current_user");
        localStorage.clear(); //clear all local storage? make sure if wont effect any other thing.
        this.getCSRF();
        return axios.post(`${process.env.Backend_URL}/logout`);
    },
    getCurrentUser() {
        return axios.get(`${process.env.API_URL}/user`);
    },
    getCleanCloudCurrentUser(userId) {
        return axios.get(`${process.env.API_URL}/get-clean-cloud-current-user/${userId}`);
    },
    
    forgetPasswordEmail(emailObj) {
        return axios.post(`${process.env.API_URL}/user/password-reset-email`, emailObj);
    },
    postResetPassword(form) {
        return axios.post(`${process.env.API_URL}/user/reset-password`, form);
    },
    updatePassword(id, form) {
        return axios.post(`${process.env.API_URL}/user/update-password/${id}`, form);
    },
    requestUsers(type, form) {
        if (type == 'put') {
            return axios.put(`${process.env.API_URL}/users/${form.id}`, form);
        }
        else if (type == 'post') {
            return axios.post(`${process.env.API_URL}/users`, form);
        } else if (type == 'delete') {
            return axios.delete(`${process.env.API_URL}/users/${form.id}`);
        }
        else {
            return axios.get(`${process.env.API_URL}/users`);
        }
    },


    createOrder(data) {
        return axios.post(`${process.env.API_URL}/create-order`, data);
    },
    getUserOrder(id){
        return axios.post(`${process.env.API_URL}/get-customer-orders/${id}`);
    },
    deleteOrder(id){
        return axios.delete(`${process.env.API_URL}/customer-delete-order/${id}`);
    },

    getOrder(id){
        return axios.post(`${process.env.API_URL}/get-order/${id}`)
    },

    getWallets(id){
        return axios.get(`${process.env.API_URL}/get-customer-wallets/${id}`)
    },
    addWallet(data){
        return axios.post(`${process.env.API_URL}/add-wallet`,data)
    },
    deleteWallet(id){
        return axios.get(`${process.env.API_URL}/remove-payment-method/${id}`)
    }
}


// WEBPACK FOOTER //
// ./src/Apis/users.js